import { useFilterShiftContext } from "./filter-shift.context";

export function FilterShift() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterShiftContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}